module.exports = __webpack_public_path__ + "static/img/undraw_not_found_60pq.889ce075.svg";